import React from "react"
import Base from "../../components/layout/Base"
import { Lockersystem } from "../../doorhub-types"
import { Text } from "pusatec-react-native"
import { useMyLockersystemPerm } from "../../components/featureParameters"
import { useTranslation } from "react-i18next"

interface Props {
	lockersystem: Pick<Lockersystem, "name" | "id">
	onPress(): void
}

export default function LockersystemLink(props: Props) {
	const { lockersystem, onPress } = props
	const { t } = useTranslation()
	const perm = useMyLockersystemPerm(lockersystem.id)
	const accessDenied = perm?.accessDenied === true
	const pressHandler = accessDenied ? undefined : onPress

	return (
		<Base
			key={lockersystem.id}
			onPress={pressHandler}
			disabled={accessDenied}
		>
			<Text text={lockersystem.name?.toUpperCase()} bold />
			{accessDenied && (
				<Text
					text={t("Lockersystem access denied")}
					style={{ color: "red", marginTop: 4 }}
				/>
			)}
		</Base>
	)
}
